import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Link, Paragraph } from '@quickmd-llc/design-system';
import { pluralize } from '@quickmd-llc/frontend-utils';
import { Events, tracking } from '@lib/events';
import { getVisitTypeUrl } from '@router/utils';
import { useAppointmentTimePreference } from '../context/useAppointmentTimePreference';
import { useParseTimeBlockSearchParam } from '../context/utils';
import { getTimeSlotsCountByTimeBlock } from './utils';

export function AllAppointmentsLink() {
  const { visitTypeId } = useParams();
  const timeBlock = useParseTimeBlockSearchParam();
  const { groupedAvailabilitiesByTimeBlock } = useAppointmentTimePreference();

  console.log(
    'groupedAvailabilitiesByTimeBlock',
    groupedAvailabilitiesByTimeBlock,
  );

  const date =
    timeBlock === 'tomorrow'
      ? dayjs().add(1, 'day').format('YYYY-MM-DD')
      : undefined;
  const seeAllAppointmentsUrl = getVisitTypeUrl(visitTypeId || '', date);

  function handleClick() {
    tracking.trackEvent(Events.CLICK_SEE_ALL_APPOINTMENTS, {
      timeBlock,
    });
  }

  if (!timeBlock) {
    return (
      <Link to={seeAllAppointmentsUrl} size="lg" onClick={handleClick}>
        View all appointments
      </Link>
    );
  }

  const timeSlotsCount = getTimeSlotsCountByTimeBlock(
    groupedAvailabilitiesByTimeBlock,
    timeBlock,
  );
  const availabilityText = getAvailabilityText(timeSlotsCount);

  return (
    <div className="grid gap-sp-1">
      <Paragraph size="sm">{availabilityText}</Paragraph>

      <Link to={seeAllAppointmentsUrl} size="lg" onClick={handleClick}>
        View all clinicians & availabilities
      </Link>
    </div>
  );
}

function getAvailabilityText(timeSlotsCount: number) {
  if (timeSlotsCount === 1) {
    return 'There is 1 other appointment available';
  }

  return `There are ${timeSlotsCount} other ${pluralize('appointment', timeSlotsCount)} available`;
}
